import React, {FunctionComponent, useEffect, useState} from 'react'

import config from "../../config/enviroment";
import {
    ContactText,
    FooterContent,
    ContactTextTitle,
    SignUp,
    FooterContainer,
    IdentityLine,
    ContactContainer,
    EpaycoContainer,
    EpaycoElements,
    EpaycoLogo,
    AccountContainer,
    AccountContent,
    SignUpContainer,
    LegalContainer,
    ContactShopContainer
} from './style';
import {useLocation,useRouteMatch} from "react-router-dom"
import useViewport from "../../hooks/useView"
import {epayconUrl} from "../../config/enviroment"
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';

type TypesProps = {
    contactEmail: string,
    contactPhone: string,
    color:string,
    bottom?: string,
    manage?: number,
}

const Footer:FunctionComponent<TypesProps> = ({ contactEmail, contactPhone, color, bottom, manage  }) => {
    const {width, display} = useViewport()
    const [showFooter,setShowFooter] = useState(true)
    const location = useLocation()
    const match:any = useRouteMatch('/vende/:idCatalog');
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    const basePath = `/vende/${match?.params.idCatalog}`
    const excludePath = [`${basePath}/categories`]

    
    useEffect(()=>{
        if(excludePath.includes(location.pathname) && (display === "mobile" || display === "tablet")){
            setShowFooter(false)
        }else{
            setShowFooter(true)
        }
        
    },[location,width])

    return (
        <>
        {showFooter &&

        <FooterContainer>
            <IdentityLine color={color}/>
            <ContactContainer>
                <FooterContent>
                
                <AccountContainer>
                    <ContactTextTitle>{language[homeState.default_language]["selling"]}</ContactTextTitle>
                    <AccountContent>
                        <ContactText>{language[homeState.default_language]["footerAdvertising"]}</ContactText>
                        <SignUpContainer> 
                            <a href = "https://dashboard.epayco.com/v3/login?utm_campaign=epayco&utm_medium=button-header&utm_source=web#registro" target="_blank" style={{textDecoration: 'none',color: '#ffffff'}}>
                                <SignUp>
                                    {language[homeState.default_language]["newAccount"]}
                                </SignUp>
                            </a>
                        </SignUpContainer>
                    </AccountContent>                    
                </AccountContainer>
                <LegalContainer>
                    <ContactTextTitle>Legal</ContactTextTitle>
                    
                    <div style={{width: '100%', display: 'flex', textAlign: 'left'}}>
                        <div className="blank-space"></div>  
                        <a href={epayconUrl} target="_blank" >
                            {language[homeState.default_language]["termsAndConditions"]}
                        </a>
                    </div>
                </LegalContainer>
                {manage === 1 ? 
                        <div>
                        </div>
                        :
                <ContactShopContainer>
                    <ContactTextTitle>{language[homeState.default_language]["contact"]}</ContactTextTitle>
                        <div className="contacts-container">
                        <div className="contact-info" >
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                    d="M3.96387 0.5C2.30701 0.5 0.963867 1.84315 0.963867 3.5V13.5C0.963867 15.1569 2.30701 16.5 3.96387 16.5H13.9639C15.6207 16.5 16.9639 15.1569 16.9639 13.5V3.5C16.9639 1.84315 15.6207 0.5 13.9639 0.5H3.96387ZM13.4023 10.681C13.7338 10.8423 13.9137 10.9646 13.942 11.0476C13.9563 11.0802 13.9634 11.1286 13.9633 11.1933C13.9633 11.3179 13.9397 11.4804 13.8922 11.681C13.8448 11.8817 13.7953 12.0397 13.743 12.1549C13.6436 12.3857 13.3549 12.6301 12.8768 12.8883C12.4317 13.1235 11.9913 13.2412 11.5558 13.2412C11.428 13.2412 11.3037 13.233 11.1829 13.2171C11.0622 13.2008 10.9262 13.172 10.7745 13.1304C10.6231 13.0889 10.5105 13.0554 10.4372 13.03C10.3638 13.0046 10.2324 12.9573 10.043 12.8882C9.85369 12.8188 9.73774 12.7774 9.69511 12.7636C9.23115 12.6021 8.81674 12.4107 8.45219 12.1894C7.84612 11.825 7.21995 11.328 6.57365 10.6985C5.92738 10.0689 5.41716 9.45878 5.04327 8.86844C4.81603 8.51327 4.61954 8.10974 4.45384 7.65771C4.43964 7.61621 4.39698 7.50326 4.32603 7.31876C4.25499 7.13421 4.20645 7.00624 4.18046 6.9348C4.15449 6.86342 4.12014 6.75379 4.07755 6.60622C4.03489 6.4586 4.00529 6.32598 3.98872 6.20838C3.97215 6.09066 3.96387 5.9696 3.96387 5.84517C3.96387 5.42089 4.08459 4.99186 4.32606 4.5584C4.59123 4.09264 4.84215 3.81131 5.0789 3.7145C5.19728 3.66369 5.35939 3.61532 5.56541 3.56921C5.77136 3.52302 5.93823 3.5 6.06614 3.5C6.13236 3.5 6.18211 3.50698 6.21527 3.52082C6.30052 3.54839 6.42596 3.72373 6.59159 4.04653C6.64373 4.13415 6.7147 4.25873 6.80462 4.42006C6.89462 4.58147 6.97741 4.72798 7.05326 4.85941C7.1291 4.99087 7.20241 5.11423 7.27336 5.22946C7.28758 5.24799 7.329 5.30559 7.39771 5.40245C7.46639 5.49935 7.51729 5.58111 7.55042 5.64811C7.58353 5.71497 7.6001 5.78076 7.6001 5.84529C7.6001 5.93751 7.53264 6.05276 7.39771 6.19115C7.26273 6.32947 7.11607 6.45634 6.95738 6.57157C6.79883 6.68679 6.65201 6.80906 6.51708 6.93815C6.38213 7.0673 6.31465 7.17344 6.31465 7.25641C6.31465 7.29797 6.32651 7.34982 6.35014 7.41208C6.37378 7.47433 6.3939 7.52163 6.41047 7.55388C6.42703 7.58625 6.46019 7.64153 6.50995 7.71997C6.55962 7.79833 6.58691 7.84217 6.59164 7.8514C6.95146 8.48332 7.36346 9.02517 7.82736 9.47729C8.29142 9.92914 8.84771 10.3304 9.49635 10.681C9.5058 10.6857 9.55068 10.7122 9.63137 10.7606C9.71192 10.8092 9.76861 10.8414 9.80165 10.8577C9.83498 10.8736 9.88354 10.8933 9.94737 10.9164C10.0112 10.9393 10.0645 10.9509 10.1072 10.9509C10.1924 10.9509 10.3014 10.8852 10.434 10.7537C10.5664 10.6222 10.6919 10.4794 10.8103 10.3248C10.9286 10.1701 11.0588 10.0273 11.2008 9.89573C11.3428 9.76437 11.4611 9.6986 11.5557 9.6986C11.622 9.6986 11.6895 9.71479 11.7582 9.74694C11.827 9.77929 11.9109 9.82889 12.0104 9.89573C12.1098 9.96275 12.169 10.003 12.1879 10.0169C12.3062 10.086 12.4328 10.1575 12.5679 10.2312C12.7028 10.3051 12.8532 10.3858 13.0189 10.4735C13.1845 10.5611 13.3125 10.6302 13.4023 10.681Z"
                                    fill="white"/>
                            </svg>
                            <div className='cellphoneWidth'>{contactPhone}</div>
                        </div>
                        <div className="contact-info">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                    d="M0.963867 3.5C0.963867 1.84315 2.30701 0.5 3.96387 0.5H13.9639C15.6207 0.5 16.9639 1.84315 16.9639 3.5V13.5C16.9639 15.1569 15.6207 16.5 13.9639 16.5H3.96387C2.30701 16.5 0.963867 15.1569 0.963867 13.5V3.5ZM13.2365 12.5001C13.4654 12.5001 13.6637 12.4245 13.8323 12.2753L10.9476 9.39053C10.8784 9.44009 10.8113 9.48829 10.7479 9.53411C10.5321 9.69316 10.3569 9.81727 10.2223 9.90621C10.0878 9.99535 9.90882 10.0862 9.68541 10.179C9.46184 10.2718 9.25356 10.3181 9.06035 10.3181H9.0547H9.04904C8.85581 10.3181 8.64753 10.2719 8.42399 10.179C8.20044 10.0862 8.02146 9.99535 7.88707 9.90621C7.75255 9.81727 7.57744 9.69318 7.36145 9.53411C7.30126 9.48999 7.23451 9.44157 7.16234 9.38976L4.27713 12.2753C4.4457 12.4245 4.64414 12.5001 4.87299 12.5001H13.2365ZM3.96387 7.07943C4.13052 7.26508 4.32193 7.4299 4.53779 7.57381C5.34238 8.12057 5.99775 8.57073 6.5064 8.92584L3.96387 11.4684V7.07943ZM13.5775 7.57381C12.8036 8.09761 12.1459 8.54855 11.6042 8.92686L14.1457 11.4685V7.07943C13.9827 7.26134 13.7934 7.42605 13.5775 7.57381ZM4.87304 4.5H13.2365C13.4827 4.5 13.6959 4.58903 13.8758 4.76699C14.0556 4.94517 14.1457 5.1591 14.1457 5.40912C14.1457 5.70837 14.0528 5.99436 13.8675 6.267C13.6818 6.53965 13.4508 6.7727 13.1743 6.96581C12.255 7.60388 11.5613 8.0856 11.0902 8.41289C10.8313 8.59264 10.6388 8.72649 10.5152 8.81247C10.4969 8.82536 10.4683 8.84571 10.4303 8.87299C10.3893 8.90229 10.3375 8.93963 10.2737 8.98579C10.1506 9.07484 10.0483 9.14678 9.9669 9.20176C9.8853 9.25663 9.78688 9.31818 9.67138 9.38639C9.55577 9.45462 9.44691 9.50574 9.34467 9.53981C9.24237 9.57386 9.14767 9.59094 9.06058 9.59094H9.05492H9.04927C8.96216 9.59094 8.86748 9.57386 8.7652 9.53981C8.66294 9.50574 8.55398 9.45451 8.43847 9.38639C8.32286 9.31818 8.22431 9.25675 8.14297 9.20176C8.06153 9.14678 7.95926 9.07482 7.83617 8.98579L7.67948 8.8729C7.64148 8.84573 7.61284 8.82524 7.59464 8.81247C7.43603 8.70093 7.24393 8.56652 7.02118 8.41131C6.75984 8.22905 6.45574 8.01783 6.10605 7.7755C5.45825 7.32671 5.06998 7.05678 4.94123 6.96581C4.70637 6.80675 4.48475 6.58806 4.27647 6.30965C4.06819 6.03113 3.96401 5.7726 3.96401 5.53401C3.96401 5.23863 4.04251 4.99233 4.19979 4.79538C4.35694 4.59853 4.58126 4.5 4.87304 4.5Z"
                                    fill="white"/>
                            </svg>
                            <div>
                                <div className="email-text">{contactEmail}</div>
                            </div>

                        </div>
                       </div>
                     </ContactShopContainer>
                    }
                </FooterContent>
            </ContactContainer>

            <EpaycoContainer bottom={bottom}>
                <EpaycoElements>

                    <EpaycoLogo>
                        <img src={`${config.urlMultimedia}/babilonia/v4/logo/new-logo-powered-epayco-black.png`}/>
                    </EpaycoLogo>

                </EpaycoElements>
            </EpaycoContainer>
        </FooterContainer>
        }
        </>

    )}
 
export default Footer
